const hiraToKata = (str) => {
  return str.replace(/[\u3041-\u3096]/g, (match) => {
    const chr = match.charCodeAt(0) + 0x60
    return String.fromCharCode(chr)
  })
}

const isPointPartiallyMatched = (point, keyword) => {
  if (!point || !keyword) return false
  const pointJaMatched = new RegExp(keyword, 'i').test(hiraToKata(point))
  return pointJaMatched
}

const isPointFullyMatched = (point, keyword) => {
  if (!point || !keyword) return false
  const pointJaFullMatched = new RegExp(`^${keyword}$`, 'i').test(hiraToKata(point))
  return pointJaFullMatched
}

export const useRiverSearch = () => {
  const result = ref([])
  const message = ref('')

  const search = (searchPointList, keyword) => {
    if (keyword === '' || searchPointList.length === 0) {
      result.value = []
      message.value = ''
      return
    }

    // 全角・半角スペースで分割し、空要素を除外
    const keywords = hiraToKata(keyword).replace(/　/g, ' ').split(' ').filter(Boolean)

    const pageList = Object.entries(pageConfig).map(([key, value]) => ({
      name: value.name,
      pref: value.pref_list.join('・'),
      path: `/${key}/`
    }))

    // 水系ページが検索できるように
    const filteredPage = pageList
      .map((page) => {
        let score = 0
        // どれかのキーワードが部分一致したら加点
        const hasPartialMatch = keywords.some((kw) => isPointPartiallyMatched(page.name, kw))
        if (hasPartialMatch) {
          score += 1
        }
        return { ...page, score }
      })
      .filter((page) => page.score > 0)
      .sort((a, b) => b.score - a.score)

    // ピンポイントの水位観測地点・カメラが検索に引っかかるように
    const filtered = searchPointList
      .map((point) => {
        let score = 0
        // AND検索: すべてのキーワードが部分一致する場合のみ加点
        const allMatched = keywords.every((kw) =>
          isPointPartiallyMatched(point.name, kw)
          || isPointPartiallyMatched(point.address, kw)
          || isPointPartiallyMatched(point.rvr_sys_nm, kw)
        )
        if (allMatched) {
          // 各キーワードごとに加点（必要なら加点ロジックを調整）
          keywords.forEach((kw) => {
            if (isPointPartiallyMatched(point.name, kw)) score += 2
            if (isPointPartiallyMatched(point.address, kw)) score += 2
            if (isPointPartiallyMatched(point.rvr_sys_nm, kw)) score += 2
            if (isPointFullyMatched(point.name, kw)) score += 1
            if (isPointFullyMatched(point.address, kw)) score += 1
            if (isPointFullyMatched(point.rvr_sys_nm, kw)) score += 1
          })
        }
        return { ...point, score }
      })
      .filter((point) => point.score > 0)
      .sort((a, b) => b.score - a.score)

    const tmpList = [...filteredPage, ...filtered]

    if (tmpList.length === 0) {
      if (filteredPage.length > 0) {
        message.value = ''
        result.value = filteredPage
      } else {
        message.value = '該当する地点がありません'
        result.value = tmpList
      }
    } else if (tmpList.length > 200) {
      if (filteredPage.length > 0) {
        message.value = ''
        result.value = filteredPage
      } else {
        message.value = `候補が多すぎます。さらに絞り込んでください。`
        result.value = []
      }
    } else {
      message.value = ''
      result.value = tmpList
    }
  }

  return {
    result,
    message,
    search
  }
}
